import { useTranslation } from 'react-i18next';
import { generatePath, useParams } from 'react-router-dom';

import { useSupplierPublicInfo } from 'services/repositories/orderForms/orderForms';
import { OrderFormsRoutes } from 'support/types';

import { LoginState } from 'pages/Auth/contexts/LoginStateContext/LoginStateContext';
import { useLoginState } from 'pages/Auth/contexts/LoginStateContext/useLoginState';

import { PasswordlessLoginForm } from '../../components/PasswordlessLoginForm/PasswordlessLoginForm';
import { PasswordlessSuccess } from '../../components/PasswordlessSuccess/PasswordlessSuccess';
import { PasswordLoginForm } from '../../components/PasswordLoginForm/PasswordLoginForm';

export const LoginForm = () => {
  const { t } = useTranslation();
  const { loginState } = useLoginState();
  const params = useParams<{ supplierSlug: string }>();
  const { data } = useSupplierPublicInfo({ variables: { supplierSlug: params.supplierSlug } });
  const orderFormRootPath = generatePath(OrderFormsRoutes.root, {
    supplierSlug: params.supplierSlug || '',
  });

  switch (loginState) {
    case LoginState.passwordless:
      return <PasswordlessLoginForm />;
    case LoginState.passwordlessSuccess:
      return (
        <PasswordlessSuccess
          confirmationText={t('auth:orderForm.passwordlessSuccessConfirmation', {
            supplierName: data?.data?.name,
          })}
          nextStepsText={t('auth:orderForm.passwordlessSuccessNextSteps')}
        />
      );
    default:
      return <PasswordLoginForm redirectTo={orderFormRootPath} />;
  }
};
